import React, { Component } from 'react';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import { withRouter } from 'react-router-dom'

/* Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json'

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainIsTenant as dit } from '../../../routes/routes'

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

import { SubViewHeader } from '../../../lib/components/subHeader';
import { IoteraForm } from '../../../lib/components/form';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const INIT_INFO = "INIT_INFO";
const WKEY = 'DEVICE_INFO';
const wBoundActions = buildWBoundActions(WKEY);
const wSelector = buildWSelector(WKEY);

function Tpl(props) {
  const { id, name, required, children } = props;
  return (
    <div className="myfield">
      <label htmlFor={id}>{name}{required ? "*" : null}</label>
      {children}
    </div>
  );
}

const schema = {
  type: "object",
  required: ["id", "serial", "name", "deviceType", "hardware"],
  properties: {
    name: { type: "string", title: "Name" },
    id: { type: "string", title: "Device Id" },
    serial: { type: "string", title: "Serial Number" },
    deviceType: { type: "string", title: "Type" }
  }
};

const uiSchema = {
  "blendMode": {
    "ui:enumDisabled": [
      "multiply"
    ]
  }
};


class DeviceInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const deviceId = safeDeepGet(_props, ['match', 'params', 'id']);
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/device/get/id/" + deviceId },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false
            })
          }
        },
        wreducer: {
          rparse: function (id, result, rpayload) {
            let device = rpayload;
            let deviceTemp = {};
            let ids = device["id"];
            deviceTemp.id = ids;
            deviceTemp.bandwidth = 57;
            deviceTemp.temperature = 36;
            deviceTemp.components = [];
            deviceTemp.length = 1;
            deviceTemp.data = 60;
            deviceTemp.deviceType = [device.category];
            deviceTemp.hardware = "Raspberry Pi";
            deviceTemp.firmware = "1.0";
            deviceTemp.name = device["name"];
            deviceTemp.location = [];
            deviceTemp.selected = false;
            deviceTemp.sensors = [];
            deviceTemp.serial = device["serial_number"];
            deviceTemp.status = [device["online"] ? "on" : "off"];
            deviceTemp.storage = 70;
            deviceTemp.cpu = 50;
            deviceTemp.memory = 20;
            return deviceTemp;
          }
        }
      }
    );
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const data = safeDeepGetWithType(_props, ['device'], {});
    let dataToShow = {
      id: data.id,
      serial: data.serial,
      name: data.name,
      deviceType: data.deviceType,
      firmware: 'v.' + data.firmware,
      temperature: data.temperature + '°C',
      hardware: data.hardware,
      storage: data.storage + '%',
      bandwidth: data.bandwidth + '%',
      memory: data.memory + '%',
      cpu: data.cpu + '%',
    }
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Info Perangkat' />
          <div className="view-content-dashboard">
            <IoteraForm
              disabled
              schema={schema}
              uiSchema={uiSchema}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
              FieldTemplate={Tpl}
              style={{ marginLeft: 10 }}
            >
              <div style={{ visibility: 'hidden' }}>
                <button type="submit">Berikutnya</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    device: wSelector.getSoleInitMappedRPayload(state)
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeviceInfo));